import ResizableScene from "../core/ResizableScene";
import Button from "../core/Button";
import ScaleManager from "../core/ScaleManager";
import SoundButton from "../core/SoundButton";
import Strings from "../core/data/Strings";
import Fonts from "../utils/Fonts";
import GameColors from "../GameColors";
import { Metrics } from "../analytics/Metrics";

export default class SplashScene extends ResizableScene {

    private playButton: Button;
    addy: Phaser.GameObjects.Image;
    courtney: Phaser.GameObjects.Image;
    kaya: Phaser.GameObjects.Image;
    deco: Phaser.GameObjects.Image;
    logo: Phaser.GameObjects.Image;
    textBacker: Phaser.GameObjects.Image;
    spine: SpineGameObject;
    bg: Phaser.GameObjects.Image;
    soundButton: SoundButton;
    sparkleContainer: SpineContainer;

    create(): void {
        Metrics.analytics.logEvent("visit_screen", { game: "ag_photobooth", screen: "splash" });
        this.music.play("menuMusic");
        const fakeBG = this.add.image(0, 0, "takePhotoBG");
        const bg = this.bg = this.add.image(0, 0, "splashBG");
        bg.setVisible(false);

        const spine = this.spine = this.add.spine(0, 0, "splash-fold", "build-in", false);
        const spineContainer = this.add.spineContainer(0, 0, spine);

        const decoContainer = this.add.container();
        const addy = this.addy = this.add.image(0, 0, "splashPhotoAddy");
        const courtney = this.courtney = this.add.image(0, 0, "splashPhotoCourtney");
        const kaya = this.kaya = this.add.image(0, 0, "splashPhotoKaya");
        const deco = this.deco = this.add.image(0, 0, "splashDecos");
        const logo = this.logo = this.add.image(0, 0, "splashLogo");
        const textBacker = this.textBacker = this.add.image(0, 0, "splashTextBacker");

        const sparkleSpine = this.add.spine(0, 0, "splash-sparkle", "idle", true);
        sparkleSpine.timeScale = 0.75;
        const sparklecontainer = this.sparkleContainer = this.add.spineContainer(0, 0, sparkleSpine);

        decoContainer.setSize(bg.width, bg.height);
        const decoBG = this.add.image(0, 0, "whiteSquare");
        decoBG.visible = false;
        decoBG.setSize(decoContainer.width, decoContainer.height);
        decoContainer.add([decoBG, addy, courtney, kaya, deco, logo, textBacker, sparklecontainer]);
        
        const playButton = (this.playButton = this.add.button(0, 0, "splashPlayBtn", undefined, this.play, this, true));
        decoContainer.add(playButton);
        playButton.clickSoundKey = "splashPlayBtn";
        const img = this.sound.mute ? "soundBtnOff" : "soundBtnOn";
        const soundButton = this.soundButton = new SoundButton(this, 0, 0, img, (mute) => {
            soundButton.setTexture(mute ? "soundBtnOff" : "soundBtnOn");
        });
        this.add.existing(soundButton);

        this.addResize((): void => {
            const width = this.viewport.width/2;
            const height = this.viewport.height/2;

            ScaleManager.ScaleBackgroundFromZone(fakeBG, this.viewport);
            spineContainer.setScale(bg.scale);
            // decoContainer.scale = bg.scale;
            //console.log(this.viewport.width, this.viewport.height);
            const screenRatio = this.viewport.width / this.viewport.height;
            const idealRatio = 16/9;
            // let scale = 1;
            // if (screenRatio < idealRatio) scale = 1 - (idealRatio - screenRatio) / 2;
            bg.scale = Math.min(screenRatio / idealRatio, 1);
            decoContainer.scale = Math.min(screenRatio / idealRatio, 1);
            this.alignIn.Center(fakeBG, this.viewport);
            this.alignIn.Center(bg, this.viewport);
            this.alignIn.Center(spineContainer, this.viewport);
            this.alignIn.Center(decoContainer, this.viewport);

            this.alignIn.Center(addy, bg, -width + 378, -height - 10);
            this.alignIn.Center(courtney, bg, -width - 386, -height + 7);
            this.alignIn.Center(kaya, bg, -width - 294, -height + 181);
            
            this.alignIn.Center(deco, bg, -width - 22, -height + 33);
            this.alignIn.Center(logo, bg, -width + 1, -height - 239);
            // logo.tint = 0xffffff;
            // if (screenRatio >= 2 || screenRatio <= 14/9) {
            //     logo.tint = 0xBC0A4D;
            //     this.alignIn.Center(logo, bg, -width + 1, -height - 195);
            // } else if (screenRatio >= 162/90) {
            //     logo.y -= 120 * (screenRatio - (162/90));
            // } else if (screenRatio <= 158/90) {
            //     logo.y -= 120 * ((158/90) - screenRatio);
            // }
            this.alignIn.Center(textBacker, bg, -width + 5, -height + 37);
            this.alignIn.Center(sparklecontainer, textBacker, 0, -20);

            this.alignIn.BottomRight(playButton, decoBG, -38, -33);
            this.alignIn.TopRight(soundButton, this.viewport, -18, -16);
        });
        this.resize();

        super.create();
        
        deco.setAlpha(0);
        
        logo.setScale(0);
        textBacker.setScale(0);
        sparklecontainer.setScale(0);
        soundButton.setScale(0);
        playButton.setScale(0);

        addy.x += addy.width * 2;
        courtney.x -= courtney.width * 2;
        kaya.x -= kaya.width * 2;

        // Build in animations
        spine.once("complete", () => {
            bg.setVisible(true);
        });

        this.tweens.add({
            targets: addy,
            x: addy.x - addy.width * 2,
            duration: 400,
            delay: 400,
            ease: Phaser.Math.Easing.Quadratic.Out,
        });

        this.tweens.add({
            targets: courtney,
            x: courtney.x + courtney.width * 2,
            delay: 500,
            duration: 400,
            ease: Phaser.Math.Easing.Quadratic.Out,
        });

        this.tweens.add({
            targets: kaya,
            x: kaya.x + kaya.width * 2,
            duration: 400,
            delay: 450,
            ease: Phaser.Math.Easing.Quadratic.Out,
        });

        this.tweens.add({
            targets: deco,
            alpha: 1,
            duration: 200,
            delay: 550,
        });

        this.tweens.add({
            targets: [logo, textBacker, sparklecontainer],
            scale: 1,
            duration: 200,
            delay: 600,
            ease: Phaser.Math.Easing.Back.Out,
            onComplete: () => {
                this.tweens.add({
                    targets: [soundButton, playButton],
                    scale: 1,
                    duration: 200,
                    ease: Phaser.Math.Easing.Back.Out,
                });
            }
        });

        // this.time.delayedCall(2500, (): void => this.build());
    }

    play(): void {
        this.playButton.disableInteractive();
        this.soundManager.play("playButton");
        this.bg.setVisible(false);
        this.spine.play("build-out", false);
        this.spine.timeScale = 7;

        this.time.addEvent({
            delay: 100,
            callback: () => {
                this.spine.timeScale = 1;
                this.tweens.add({
                    targets: this.deco,
                    alpha: 0,
                    duration: 100,
                    delay: 200,
                });
        
                this.tweens.add({
                    targets: [this.logo, this.textBacker, this.sparkleContainer],
                    scale: 0,
                    duration: 300,
                    ease: Phaser.Math.Easing.Back.In,
                });
        
                this.tweens.add({
                    targets: [this.soundButton, this.playButton],
                    scale: 0,
                    duration: 300,
                    ease: Phaser.Math.Easing.Back.In,
                });
        
                this.tweens.add({
                    targets: this.addy,
                    x: this.addy.x + this.addy.width * 2,
                    duration: 300,
                    ease: Phaser.Math.Easing.Back.In,
                });
        
                this.tweens.add({
                    targets: this.courtney,
                    x: this.courtney.x - this.courtney.width * 2,
                    delay: 100,
                    duration: 300,
                    ease: Phaser.Math.Easing.Back.In,
                });
        
                this.tweens.add({
                    targets: this.kaya,
                    x: this.kaya.x - this.kaya.width * 2,
                    duration: 300,
                    delay: 50,
                    ease: Phaser.Math.Easing.Back.In,
                });
            }
        });

        this.time.addEvent({
            delay: 1100,
            callback: () => {
                this.scene.start("PhotoSelectScene");
            }
        });
    }

    shutdown(): void {
        // this._onPlayAnim = null;
        // this._settingsButton = null;
        // this._onResize = null;
        super.shutdown();
    }
}
